export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14381.10815b85.jpg";